import { CommonModule } from '@angular/common';
import { Component, effect, inject, model } from '@angular/core';
import { injectQueryParams } from 'ngxtension/inject-query-params';
import {
  SafeHtmlPipe,
  Segment,
  PageModalContainer,
} from '@millionshow/client-libs';
import { MARKETING_KEY, PRIVACY_KEY, USE_KEY } from '@millionshow/common';
import { StorageService } from '@millionshow/api-client';
import { rxResource } from '@angular/core/rxjs-interop';
import { catchError, map, of } from 'rxjs';
import { NotFoundComponent } from '../../components/not-found/not-found.component';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-policy-page',
  imports: [
    CommonModule,
    Segment,
    SafeHtmlPipe,
    PageModalContainer,
    NotFoundComponent,
  ],
  templateUrl: './policy.page.html',
})
export default class PolicyPage {
  private readonly storageService = inject<StorageService>(StorageService);
  private readonly queryParams = injectQueryParams();
  private readonly seoService = inject(SeoService);

  options = [
    { label: '이용약관', value: USE_KEY },
    { label: '개인정보처리방침', value: PRIVACY_KEY },
    { label: '마케팅활용동의', value: MARKETING_KEY },
  ];

  segment = model(USE_KEY);

  constructor() {
    effect(() => {
      const params = this.queryParams();
      const type = params['type'];
      if (type === 'privacy') {
        this.segment.set(PRIVACY_KEY);
      } else if (type === 'marketing') {
        this.segment.set(MARKETING_KEY);
      } else {
        this.segment.set(USE_KEY);
      }
    });

    effect(() => {
      const segment = this.segment();
      const title =
        segment === PRIVACY_KEY
          ? '개인정보처리방침'
          : segment === MARKETING_KEY
          ? '마케팅 활용 동의'
          : '이용약관';

      this.seoService.set({
        title,
        description:
          '밀리언쇼 이용약관, 개인정보처리방침, 마케팅 활용 동의 내용을 확인해보세요.',
        path: '/policy',
      });
    });
  }

  $term = rxResource({
    stream: ({ params }) =>
      this.storageService
        .storageControllerGetTerms({
          key: params.key,
        })
        .pipe(
          map(res => res['text'] || ''),
          catchError(() => of(''))
        ),
    params: () => ({
      key: this.segment(),
    }),
  });
}
